module.exports = "https://static.energy5.com/_next/static/images/perfect4-47f94cd8beaefac9acb1ac1ee8d2a957.png";